<section *ngIf="reportSearch" class="px-6 py-0">

    <div *ngIf="company" class="grid grid-cols-3 gap-6 mb-6">

        <!-- Company Contact -->
        <div class="col-span-3 xl:col-span-1 order-first lg:order-first">
          <app-company-contact [report]="reportSearch" [company]="company" (editContactModalRequested)="editContactModalRequested.emit($event)"></app-company-contact>
        </div>

        <!-- Person Insights -->
        <div class="col-span-3 xl:col-span-2 order-last lg:order-last">
          <h2 class="sr-only">Company Insights</h2>
          <!-- AI Agent Tool Box - always visible -->
          <app-ai-agent-tool-box [reportSearch]="reportSearch"
                                 [company]="company"
                                 (enrichRequested)="onEnrichProfile()">
          </app-ai-agent-tool-box>

        </div>

    </div>

    <!-- Company News - full width, shown after enrichment, above Expertise -->
    <div *ngIf="company && reportSearch.is_enrich === 1" class="mb-6">
      <div class="blue-card p-6">
          <dl>
              <div class="flex justify-between w-full mb-6">
                  <h2 class="text-xl text-secondary-900 dark:text-white font-semibold">Company news</h2>

                  <div>
                      <svg viewBox="0 0 15 20" class="w-6 h-6" fill="none">
                          <path d="M6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8H8.5C9.05228 8 9.5 7.55228 9.5 7C9.5 6.44772 9.05228 6 8.5 6H6.5Z" fill="#1B9ED1"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 16V13.3264C12.8649 12.2029 14.5 9.7924 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 9.7924 2.13505 12.2029 4.5 13.3264V16C4.5 16.5523 4.94772 17 5.5 17H9.5C10.0523 17 10.5 16.5523 10.5 16ZM9.64182 11.5198L8.63107 12H6.36893L5.35818 11.5198C3.66429 10.7152 2.5 8.99156 2.5 7C2.5 4.23858 4.73858 2 7.5 2C10.2614 2 12.5 4.23858 12.5 7C12.5 8.99156 11.3357 10.7152 9.64182 11.5198ZM6.5 15V14H8.5V15H6.5Z" fill="#1B9ED1"/>
                          <path d="M7.5 20C8.60457 20 9.5 19.1046 9.5 18H5.5C5.5 19.1046 6.39543 20 7.5 20Z" fill="#1B9ED1"/>
                      </svg>
                  </div>
              </div>

              <div>
                <app-assistant-prompt tag="ASK_ASSISTANT_COMPANY_NEWS"
                                      [type]="'company-news'"
                                      [company]="company"
                                      [reportId]="reportSearch?.id">
                </app-assistant-prompt>
              </div>

          </dl>

      </div>
    </div>

    <div *ngIf="company">

      <!-- Company Information -->
      <div *ngIf="isEnriched" class="card p-6 border-2 border-violet-200 shadow-[inset_0_0_30px_rgba(237,233,254,0.5)]">

          <div class="animate-fadeIn">
            <app-expertise
              [edit]="edit"
              [reportSearch]="reportSearch"
              [company]="company">
            </app-expertise>
          </div>

          <div class="animate-fadeIn">
            <app-background
              [edit]="edit"
              [reportSearch]="reportSearch"
              [company]="company">
            </app-background>
          </div>

          <div class="animate-fadeIn">
            <app-company-information
              [report]="reportSearch"
              [company]="company">
            </app-company-information>
          </div>

      </div>

      <!--
      <div>
        <app-emails [report]="reportSearch" [company]="company"></app-emails>
      </div>
      -->

      <!-- Team -->
      <!--
      <app-team [report]="reportSearch"
                [company]="company"
                [edit]="edit">
      </app-team>
      -->

      <!-- Ecosystem
      <app-ecosystem [report]="reportSearch"
                     [company]="company"
                     [edit]="edit">
      </app-ecosystem>
      -->

    </div>

    <div *ngIf="!company" class="card p-6">
      <p class="text-sm">Company information was not found.</p>
    </div>

</section>
